import './App.css';
import Greeting from './Greeting';
import CompareForm from './CompareForm';

function App() {
  return (
    <div className="App">
      <Greeting name="Jack Rosa"/>
      <CompareForm />
    </div>
  );
}

export default App;
